<script setup>
import ChartBar from '../chart/ChartBar.vue'
import { useStationDataStore } from '~/stores/stations'
import AppLoadingWrapper from '~/components/app/AppLoadingWrapper.vue'
import FuelTypeOverview from '~/components/region-statistics/FuelTypeOverview.vue'

const stationStore = useStationDataStore()
const electricityOrigin = computed(() => stationStore.getElectrictyOrigin)
const stationsGroupedByFuelTypeArray = computed(() => {
  return stationStore.getExistingStationCountGropedByFuelType.map((item) => ({
    label: item.fuelType.title,
    value: item.stationCount,
  }))
})
</script>
<template>

  <FuelTypeOverview />
  <AppLoadingWrapper :is-loading="stationsGroupedByFuelTypeArray.length === 0" :height="100">
    <ChartBar :data="stationsGroupedByFuelTypeArray" direction="vertical" />
    <DataSource
      :source-data="[
        { identifier: electricityOrigin },
        { identifier: 'tankaGront' },
        { identifier: 'energimyndigheten' },
        { identifier: 'trafikverket' },
        { identifier: 'klimatklivet' },
        { identifier: 'biofuelExpress' },
        { identifier: 'energigasSverige' },
      ]"
    />
  </AppLoadingWrapper>
</template>
